import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/services' },
  { label: 'About', href: '/about' },
  { label: 'Locations', href: '/locations' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-warm-white/98 border-b border-cream'
            : 'bg-transparent'
        }`}
        style={scrolled ? { backdropFilter: 'blur(12px)' } : {}}
      >
        <div className="px-4 md:px-8 flex items-center justify-between h-20 md:h-22"
          style={{ height: scrolled ? '72px' : '88px', transition: 'height 0.5s ease' }}>
          {/* Logo */}
          <Link to="/" className="flex flex-col leading-none cursor-pointer">
            <span
              className={`font-serif text-xl md:text-2xl font-light tracking-wide transition-colors duration-500 ${
                scrolled ? 'text-charcoal' : 'text-white'
              }`}
            >
              Cam Kirkwood
            </span>
            <span
              className={`text-[8px] tracking-[0.35em] uppercase mt-0.5 transition-colors duration-500 ${
                scrolled ? 'text-gold' : 'text-white/70'
              }`}
            >
              Luxury Real Estate &bull; Lake Tahoe &amp; Sierra Nevada
            </span>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-[12px] tracking-[0.15em] uppercase transition-colors duration-300 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.href
                    ? 'text-gold'
                    : scrolled
                    ? 'text-charcoal hover:text-gold'
                    : 'text-white/85 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Right: phone + CTA */}
          <div className="hidden md:flex items-center gap-5">
            <a
              href="tel:5617146589"
              className={`flex items-center gap-2 text-sm font-medium tracking-wide whitespace-nowrap transition-colors duration-300 cursor-pointer ${
                scrolled ? 'text-charcoal hover:text-gold' : 'text-white/85 hover:text-white'
              }`}
            >
              <i className={`ri-phone-line text-gold text-sm`} />
              561-714-6589
            </a>
            <a
              href="#consultation"
              className={`whitespace-nowrap px-5 py-2.5 text-[11px] tracking-[0.18em] uppercase font-medium cursor-pointer rounded-md transition-all duration-300 ${
                scrolled
                  ? 'bg-gold text-white hover:bg-[#b8983a]'
                  : 'bg-white/15 text-white border border-white/30 hover:bg-gold hover:border-gold'
              }`}
            >
              Schedule Consultation
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden cursor-pointer p-2"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i
              className={`text-2xl transition-colors duration-300 ${
                menuOpen || scrolled ? 'text-charcoal' : 'text-white'
              } ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}
            />
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 z-40 bg-warm-white transition-transform duration-500 ${
          menuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="pt-24 px-8 flex flex-col gap-6">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className="font-serif text-3xl text-charcoal cursor-pointer hover:text-gold transition-colors"
            >
              {link.label}
            </Link>
          ))}
          <div className="mt-6 pt-6 border-t border-cream">
            <a
              href="tel:5617146589"
              className="flex items-center gap-2 text-stone mb-5 text-sm tracking-wide"
            >
              <i className="ri-phone-line text-gold" /> 561-714-6589
            </a>
            <a
              href="#consultation"
              onClick={() => setMenuOpen(false)}
              className="inline-block whitespace-nowrap px-6 py-3.5 bg-gold text-white text-[11px] tracking-[0.2em] uppercase font-medium cursor-pointer rounded-md"
            >
              Schedule Consultation
            </a>
          </div>
        </div>
      </div>
    </>
  );
}